import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { PageSection } from 'Components/Layout';
import {
  WorksheetImagesAndRemarksSection,
  WorksheetResultsSection,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import { WorksheetRootComponent } from 'Components/Worksheets/Core/types';
import ids from '../../QestIds';
import { AsLaboratoryMoistureContent, AsMeasurementSection, AsPreparationSection, AsResultsSection } from './Sections';

const qestids = [ids.nuclearFieldDensity.AS_1289_5_8_1.rev2007];

let NuclearFieldDensityWorksheet: WorksheetRootComponent = ({ createWorksheetSelector }) => {
  return (
    <>
      <AsPreparationSection />
      <AsMeasurementSection />
      <AsLaboratoryMoistureContent />
      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>
      <WorksheetResultsSection heading="Results">
        <AsResultsSection />
      </WorksheetResultsSection>
      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

NuclearFieldDensityWorksheet.qestIds = qestids;
const AsNuclearFieldDensityWorksheet = withInjectedProps(NuclearFieldDensityWorksheet);

export { AsNuclearFieldDensityWorksheet };
export default AsNuclearFieldDensityWorksheet;
